import { WhatsappMessageType } from "@jugl-web/rest-api";
import { SUPPORTED_WHATSAPP_PAYLOAD_TYPES } from "../consts";

export const isWhatsappPayloadSupported = (payloadType: WhatsappMessageType) =>
  SUPPORTED_WHATSAPP_PAYLOAD_TYPES.includes(payloadType);
